import { render, staticRenderFns } from "./Bounced.vue?vue&type=template&id=81643ab4&scoped=true&"
import script from "./Bounced.vue?vue&type=script&lang=js&"
export * from "./Bounced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81643ab4",
  null
  
)

export default component.exports